<template>
<!--  <a-spin :spinning="isLoading">-->
    <div>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :import-config="importConfig"
        :export-config="exportConfig"
        ref="grid"
        :cellClick="chooseRow"
        :cell-db-click="updateRow"
        @toolbar-addData="addRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <vxe-button @click="synchronization()">同步数据</vxe-button>
        <vxe-button @click="chooseOpenPop('checkResult')">查看发表情况</vxe-button>
      </template>
    </x-grid>

    <!--  弹出层  -->
    <popModal title="查看发表情况" :pop-config="popConfig.checkResult" >
      <checkResult ref="checkResult"
                   :taskId="popConfig.checkResult.id"
                   :row="popConfig.checkResult.row"
                   :type="'checkResult'"
                   @closePop="closePopAndRefresh"
      ></checkResult>
    </popModal>


    <!--明细页表单简化通用写法-->
    <formModal title="群发朋友圈" :visible="editModalVisible">
      <detailForm :rowId="editRowId"
                  v-if="editModalVisible"
                  ref="detailForm"
                  @cancelled="closeEdit()"
                  @saved="closeEdit(true)">
      </detailForm>
    </formModal>
    </div>
<!--  </a-spin>-->
</template>

<script>
import {
  GridMixin,
  api,
  fac,
  fmt
} from "@/utils/common/XGridBase"

import detailForm from "./MassSendCircleDetail";
import {dataApi} from "@/services/operate/MassSendCircle";
import checkResult from "@/pages/web/operate/MassSendCircle/list/checkResult";

//列表接口
const url = api.operate.MASS_SEND_CIRCLE;

//主键
const rowId = 'taskId';

//列
const columns = [
  // fac.makeColumnRadioDefault(),
  fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("taskTitle", "标题", 160),
  fac.makeColumn("content", "内容", 300),
  fac.makeColumn("userName", "创建人", 160),
  fac.makeColumn("createDate", "创建时间", 160),
  fac.makeColumn("momentId", "是否可同步", 140, 'center', true, fmt.formatStringYesNo)
]

//筛选项
const formConfig = fac.makeFormConfig(columns, [
  {field: 'userName'},
  {field: 'createDate', type: 'dateRange'},
])

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  import: false,
  export: false,
  delData: false,
  addData: true,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);
const popConfig = fac.makePopConfig(['checkResult']);

async function loadBaseData() {

}

export default {
  mixins: [GridMixin],
  components: {
    detailForm,
    checkResult
  },
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      popConfig,
    }
  },
  async mounted() {
    // let that = this;
    // setInterval(()=>{
    //   console.log(that.$refs['grid'].$refs['xGrid'].getFormItems())
    // },1000)
  },
  methods: {
    loadBaseData,
    async synchronization() {
      let row = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (row.length !== 1) {
        this.$message.error('请选择一条数据');
        return;
      }

      this.loading(true);
      await dataApi.synchronization(row[0][this.rowId]).then(() => {
        this.$message.success('同步成功');
        this.loading(false);
      }).catch(() => {
        this.loading(false);
      });
      this.refresh()
    },

  }
}
</script>

<style scoped>
</style>